import { Component, OnInit } from '@angular/core';
import { NgbDateAdapter, NgbDateNativeAdapter } from '@ng-bootstrap/ng-bootstrap';
import { ReportService } from 'src/app/services/report.service';
import { NativeDateAdapter } from 'src/app/adapters/native-date-adapter';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-gas-report',
  templateUrl: './gas-report.component.html',
  styleUrls: ['./gas-report.component.css'],
  providers: [{provide: NgbDateAdapter, useClass: NgbDateNativeAdapter}]
})
export class GasReportComponent implements OnInit {

  date1:Date = new Date();
  date2:Date = new Date();
  data = [];
  loading:boolean = false;
  total:number = 0;
  totalLts:number = 0;
  expand:boolean = false;

  constructor(private repServ:ReportService) { 
    this.date1.setDate(this.date1.getDate() - 30);
  }

  ngOnInit() {
    this.search();
  }

  search() {
    this.loading = true;
    this.repServ.gasReport(this.date1, this.date2)
      .then(resp => {
        this.data = resp;
        this.total = this.data.reduce((ant, act) => Number(ant) + (act.gas_ticket ? 0 : Number(act.total)), 0)
        this.totalLts = this.data.reduce((ant, act) => Number(ant) + (act.gas_ticket ? 0 : Number(act.quantity)), 0)
        this.loading = false;
      });
  }

  download(type) {
    window.open(environment.baseUrl + '/' + type + '/gas' + '?date1=' + this.date1.toString() + '&date2=' + this.date2.toString(), '_blank')
  }
}
